import { put } from '../utils'
import { makeJsonData } from './utils'

export default host => ( {
  id,
  dates
}) => put(`${host}/contentCreators/${id}/events`, makeJsonData({dates}))
